module.exports = __webpack_public_path__ + "static/media/Honesty.1fde284b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Wealth/img/Honesty.png
// module id = 704
// module chunks = 0